if (!customElements.get('recently-viewed-products')) {
  const BaseClass = customElements.get('card-product-slider') || HTMLElement;

  class RecentlyViewed extends BaseClass {
    constructor() {
      super();

      this.section = this.closest('.js-section');
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.productHandle = this.dataset.productHandle;

      this.fetchRecentProducts();

      if (document.querySelector("quick-cart-drawer") && this.querySelector('.swiper-slide')) {
        document.querySelector("quick-cart-drawer").init();
      }

      if (Shopify.designMode) {
        if (document.querySelector("quick-cart-drawer") && this.querySelector('.swiper-slide')) {
          document.querySelector("quick-cart-drawer").init();
        }
      }
    }

    fetchRecentProducts() {
      const productHandles = localStorage.getItem('recently-viewed');

      if (!productHandles) {
        return;
      }

      const productHandlesArray = productHandles
        .split(',')
        .filter(
          productHandle => productHandle !== this.productHandle
        );

      if (productHandlesArray.length === 0) {
        return;
      }

      productHandlesArray.forEach((productHandle, i) => {
        const addRecentProducts = async () => {
          try {
            const fetchUrl = `${window.Shopify.routes.root}products/${productHandle}?view=card`;

            const productCardResponse = await fetch(fetchUrl);

            if (!productCardResponse.ok) {
              const storedHandles = localStorage.getItem('recently-viewed');
              const updatedProductHandles = storedHandles
                .replace(`${productHandle},`, '')
                .replace(productHandle, '');
              localStorage.setItem('recently-viewed', updatedProductHandles);
              return;
            }

            const productCardHTML = await productCardResponse.text();

            if (!productCardHTML.trim()) {
              return;
            }

            const productSlide = document.createElement('DIV');
            productSlide.classList.add(
              'swiper-slide',
              'card-product-slider__slide'
            );
            productSlide.insertAdjacentHTML(
              'beforeend',
              productCardHTML
            );

            if (
              !productSlide.querySelector('product-card') &&
              !productSlide.querySelector('.product-card')
            ) {
              return;
            }

            const buttonRecently = document.getElementById('button-recently');
            if (buttonRecently) {
              buttonRecently.classList.remove('hidden');
            }

            this.sliderWrapper.append(productSlide);

          } catch (error) {
            console.error(`Errore durante la fetch per ${productHandle}:`, error);
          } finally {
              const isLastIteration = i === productHandlesArray.length - 1;
              if (!isLastIteration) return;

              this.section?.classList.remove('hidden');
              // Aspetta che il DOM sia aggiornato e poi aggiorna Swiper
              setTimeout(() => {
                this.initSlider();
                this.swiperInstance?.update();
              }, 50);
            }
        };

        addRecentProducts();
      });
    }

    initSlider() {
  if (this.swiperInstance) {
    this.swiperInstance.update();
    return;
  }
  this.swiperInstance = new Swiper(this.querySelector('.ProductSwiper'), {
    navigation: {
      nextEl: ".recent-arr.swiper-button-next",
      prevEl: ".recent-arr.swiper-button-prev",
    },
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        spaceBetween: 5,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
}
  }

  customElements.define('recently-viewed-products', RecentlyViewed);
}